import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { CleanType } from '@ac/library-api';
import { AcFormElement } from '@ac/mobile-components/dist/components/form-element';
import {
  AcModal,
  AcModalBody,
  AcModalHeader,
  AcModalPattern
} from '@ac/mobile-components/dist/components/modal';

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  cleanType: CleanType;
}

const CleanTypeDescriptionModal: FC<Props> = (props: Props) => {
  const { t } = useTranslation();

  const { description, longDescription } = props.cleanType;

  return (
    <AcModal
      isOpen={props.isVisible}
      onClose={props.onClose}
      pattern={AcModalPattern.Drawer}
    >
      <AcModalHeader showCloseButton={true}>
        {t('GLOBAL.CLEARING_TYPE.TITLE')}
      </AcModalHeader>
      <AcModalBody>
        <AcFormElement label={t('CLEAN_TYPE.DESCRIPTION')}>
          <>{description || ''}</>
        </AcFormElement>
        {longDescription && (
          <AcFormElement
            className="ac-spacing-top-md"
            label={t('CLEAN_TYPE.LONG_DESCRIPTION')}
          >
            <>{longDescription || ''}</>
          </AcFormElement>
        )}
      </AcModalBody>
    </AcModal>
  );
};

export default memo(CleanTypeDescriptionModal);



// WEBPACK FOOTER //
// ./src/components/shared/CleanTypeDescriptionModal/CleanTypeDescriptionModal.tsx